import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Typography, Box, Chip, CircularProgress
} from '@material-ui/core';
import {  makeStyles , useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '520px',
    
    color: '#f8fafc'
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-root': { color: '#f8fafc' },
    '& .MuiInputLabel-root': { color: theme.palette.text.secondary },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#334155' },
  },
  label: { color: theme.palette.text.secondary, fontSize: '0.8rem', marginBottom: 4 },
  value: { color: theme.palette.text.primary, marginBottom: 12 },
  replyBox: {
    background: 'rgba(16,185,129,0.08)',
    border: '1px solid rgba(16,185,129,0.2)',
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
  },
}));

const statusColors = {
  open: '#ef4444',
  closed: '#64748b',
  in_progress: '#f59e0b',
};

export default function TicketDetailDialog({ open, ticket, onClose, onSave }) {
  const classes = useStyles();
  
  const theme = useTheme();
const [reply, setReply] = useState(ticket?.adminReply || '');
  const [status, setStatus] = useState(ticket?.status || 'open');
  const [saving, setSaving] = useState(false);

  if (!ticket) return null;

  const handleSave = async () => {
    setSaving(true);
    const data = { adminReply: reply };
    if (ticket.status !== 'closed' && status === 'closed') {
      data.status = 'closed';
    }
    if (reply.trim()) {
      data.repliedAt = new Date();
    }
    await onSave(ticket.id, data);
    setSaving(false);
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString();
  };

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }} maxWidth="sm" fullWidth>
      <DialogTitle>Support Ticket Details</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography className={classes.label}>User</Typography>
          <Typography className={classes.value}>{ticket.userName} ({ticket.userEmail})</Typography>
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Status</Typography>
          <Chip
            label={ticket.status || 'open'}
            size="small"
            style={{
              backgroundColor: `${statusColors[ticket.status] || '#64748b'}20`,
              color: statusColors[ticket.status] || '#94a3b8',
              fontWeight: 600,
            }}
          />
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Subject</Typography>
          <Typography className={classes.value}>{ticket.subject}</Typography>
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Submitted</Typography>
          <Typography className={classes.value}>{formatDate(ticket.createdAt)}</Typography>
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Message</Typography>
          <Typography className={classes.value} style={{ whiteSpace: 'pre-wrap' }}>{ticket.message}</Typography>
        </Box>

        {ticket.adminReply && (
          <Box className={classes.replyBox} mb={2}>
            <Typography className={classes.label} style={{ color: '#10b981' }}>Your Reply</Typography>
            <Typography className={classes.value} style={{ whiteSpace: 'pre-wrap' }}>{ticket.adminReply}</Typography>
            {ticket.repliedAt && (
              <Typography style={{ color: theme.palette.text.secondary, fontSize: '0.75rem' }}>
                {formatDate(ticket.repliedAt)}
              </Typography>
            )}
          </Box>
        )}

        <TextField
          label="Admin Reply"
          fullWidth
          multiline
          minRows={3}
          variant="outlined"
          className={classes.textField}
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          placeholder="Write your reply to the user..."
        />

        <Box mt={1}>
          <Typography className={classes.label} style={{ marginBottom: 8 }}>Update Status</Typography>
          <Box display="flex" gap={1}>
            {['open', 'in_progress', 'closed'].map((s) => (
              <Chip
                key={s}
                label={s.replace('_', ' ')}
                clickable
                color={status === s ? 'primary' : 'default'}
                onClick={() => setStatus(s)}
                style={{
                  backgroundColor: status === s ? `${statusColors[s]}30` : 'rgba(148,163,184,0.1)',
                  color: status === s ? statusColors[s] : '#94a3b8',
                  fontWeight: 600,
                  border: status === s ? `1px solid ${statusColors[s]}` : '1px solid transparent',
                }}
              />
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions >
        <Button onClick={onClose} color="textSecondary">Close</Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disableElevation
          disabled={saving}
        >
          {saving ? <CircularProgress size={20} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
